import { useEffect } from 'react';
import { PANEL_URL } from '../lib/api';

/** turnivo.pl/register → przekierowanie na rejestrację w panelu. */
export default function RedirectToPanelRegister() {
  useEffect(() => {
    window.location.href = `${PANEL_URL}/register`;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <p className="text-slate-600">Przekierowuję do rejestracji w panelu…</p>
    </div>
  );
}
